var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect2, _rect3, _path12, _path13, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 824 182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9d702f;}.cls-2{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 824,
    height: 182,
    rx: 26.38
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206.38,929.5a25.91,25.91,0,0,1-25.88-25.88V774.38a25.91,25.91,0,0,1,25.88-25.88H362.5v181Z",
    transform: "translate(-180 -748)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M362,749V929H206.38A25.41,25.41,0,0,1,181,903.62V774.38A25.41,25.41,0,0,1,206.38,749H362m1-1H206.38A26.38,26.38,0,0,0,180,774.38V903.62A26.38,26.38,0,0,0,206.38,930H363V748Z",
    transform: "translate(-180 -748)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M239.37,785.68a78.51,78.51,0,0,0-3.71,111l.08-.08v-5.79a74.66,74.66,0,0,1,3.52-99.45l35.85,38.34,2.49-2.49Z",
    transform: "translate(-180 -748)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M239.3,797.15a70.75,70.75,0,0,0-3.56,87.21v-7.18a66.86,66.86,0,0,1,3.8-74l30,32.07,2.79-2.79Z",
    transform: "translate(-180 -748)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M240,809.46a62.85,62.85,0,0,0-4.27,59.12V856.16a58.8,58.8,0,0,1,5-40.1l23.16,24.77,2.79-2.78Z",
    transform: "translate(-180 -748)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M343,840.39a78.31,78.31,0,0,0-24.84-54.71l-38.54,41.19,2.79,2.79,35.86-38.33a74.68,74.68,0,0,1,3.52,99.46v5.78l.08.08A78.3,78.3,0,0,0,343,840.39Z",
    transform: "translate(-180 -748)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M321.75,884.36a70.75,70.75,0,0,0-3.56-87.21l-33,35.31,2.79,2.79,30-32.08a66.86,66.86,0,0,1,3.8,74v7.19Z",
    transform: "translate(-180 -748)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M321.75,868.58a62.85,62.85,0,0,0-4.27-59.12L290.75,838l2.79,2.79,23.17-24.77a58.8,58.8,0,0,1,5,40.1v12.42Z",
    transform: "translate(-180 -748)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M449.79,877l-23.93-47v47H414.5l.06-71.77h11.31L456,864.84l29.77-60.05H497v72.07H485.73V830l-23.54,47Z",
    transform: "translate(-180 -748)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M508.62,876.9l38.92-71.48h8.6L594.73,877H582.07L574,861.62l-5.25-9.76-17-30.47-30.09,55.52h-13Z",
    transform: "translate(-180 -748)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M657.63,805.33H670.3l-38.59,71.53H623.1l-38.92-71.49h13l30.1,55.52Z",
    transform: "translate(-180 -748)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 503.18,
    y: 57.23,
    width: 11.26,
    height: 71.72
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 537.28,
    y: 57.23,
    width: 11.26,
    height: 71.72
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M804.74,860.11V805.18h11.31V876.9H804.63l-45.08-54.34V876.9H747.86V805.18h10.77Z",
    transform: "translate(-180 -748)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M895.62,815.43H852.7q-8.13,0-8.12,8v35.79c0,5,2.87,7.47,8.71,7.47h42.27l.06,10.25-45.52-.05q-17,0-17-15.33l.06-41q0-15.42,16.94-15.42h45.47Z",
    transform: "translate(-180 -748)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 736.18,
    y: 57.23,
    width: 11.26,
    height: 71.72
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceLogo);
export default __webpack_public_path__ + "static/media/invoice-logo.eb9b19edc67182ec6b57d2179896fcfd.svg";
export { ForwardRef as ReactComponent };